import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {IConversationTypeInterfacesMap} from '@toolify/server/src/services/MessageService/types/IConversationTypeInterfacesMap'

type AnyConversationPayload = IConversationTypeInterfacesMap[ConversationType]['conversationTypePayload']
type DirectPayload = IConversationTypeInterfacesMap[ConversationType.Direct]['conversationTypePayload']

export function useDirectConversationTypeStrategy() {
  const getConversationKey = (payload: AnyConversationPayload): string => {
    return (payload as DirectPayload).directConversationId
  }

  const getRelayConversationKey = (payload: AnyConversationPayload): string => {
    return (payload as DirectPayload).directConversationId
  }

  return {
    getConversationKey,
    getRelayConversationKey,
  }
}
